<template>
  <div class="content" v-loading="loading">
    <div class="header">
      <el-button @click="getCustomerExcel(1)">预览</el-button>
      <el-button @click="getCustomerExcel(0)">导出</el-button>
      <el-button @click="back">返回</el-button>
    </div>
    <div class="body">
      <el-descriptions :column="1" direction="vertical" border>
        <el-descriptions-item size="mini">
          <template slot="label">
            <span style="font-weight: bold;color: black;font-size: 18px;">项目房态占比统计</span>
          </template>
          <el-descriptions size="mini" :column="1" border :label-style="{width:'100px'}" :contentStyle="{maxWidth:'300px',wordBreak:'break-all'}">
            <el-descriptions-item label="项目">
              <select-projects v-if="ReportCustomer.customerMenuIndex=='HouseRoomStatus'" v-model="where.project_ids" />
            </el-descriptions-item>
            <el-descriptions-item label="房产类型">
              <el-checkbox-group size="mini" v-model="where.house_type" style="width: 100%;">
                <el-checkbox label="1">住宅</el-checkbox>
                <el-checkbox label="2">车位</el-checkbox>
                <el-checkbox label="3">储藏室</el-checkbox>
                <el-checkbox label="4">商铺</el-checkbox>
                <el-checkbox label="5">写字楼</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>
<!--            <el-descriptions-item label="费项">-->
<!--              <select-charge-item-name v-if="ReportCustomer.customerMenuIndex=='HouseRoomStatus'" :ids="where.charge_item_name_ids" />-->
<!--            </el-descriptions-item>-->
          </el-descriptions>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <ViewFile ref="ViewFile" />
  </div>
</template>

<script>
import AppConfig from "../../../../config/AppConfig";
import ViewFile from "../../Common/ViewFile";
import SelectProjects from "./common/selectProjects";
import SelectChargeItemName from "./common/selectChargeItemName";

export default {
  name: "HouseRoomStatus",
  components: {SelectChargeItemName, SelectProjects, ViewFile},
  inject:['ReportCustomer'],
  data(){
    return{
      where:{
        project_ids:[],
        charge_item_name_ids:[],
        house_type:['1','4','5'],

      },
      loading:false,
    }
  },
  mounted() {
    // this.where.house_name=this.ReportCustomer.house_name;
    // this.where.project_id=this.ReportCustomer.project_id;
  },
  methods:{
    back(){
      this.ReportCustomer.customerMenuIndex="CustomerMain";
    },
    getCustomerExcel(ready_type=1){
      const that=this;
      that.loading=true;
      let where=ERP.reJson(that.where)
      where.house_type=where.house_type.join(',');
      where.project_ids=where.project_ids.join(',');
      where.charge_item_name_ids=where.charge_item_name_ids.join(',');
      ERP.postRequest({
        url: "admin/Customer/getProjectRoomStatusExcel",
        data: where
      }, res => {
        if (res.code) {
          if(ready_type===1){
            that.$refs.ViewFile.show({
              width: '90vw',
              height:'80vh',
              title:"预览文件",
              src:AppConfig.erp_server+res.data,
              download(){
                // TODO 下载文件逻辑
                window.open(AppConfig.erp_server+res.data)
              }
            })
          }else {
            window.open(AppConfig.erp_server+res.data);
          }
        }
        that.loading = false;
      })
    }
  },

}
</script>

<style lang="scss" scoped>
.content{
  .header{
    display: flex;
    flex-direction: row;
  }
  .body{
    margin-top: 10px;

    .c-input{
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/HouseRoomStatus.vue